import { render, staticRenderFns } from "./VehiclesScreen.vue?vue&type=template&id=1fe17d01&scoped=true&"
import script from "./VehiclesScreen.vue?vue&type=script&lang=js&"
export * from "./VehiclesScreen.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesScreen.vue?vue&type=style&index=0&id=1fe17d01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe17d01",
  null
  
)

export default component.exports